var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":100,"width":"6","indeterminate":"","color":"primary"}},[_vm._v(_vm._s(_vm.progressCircularText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }